'use strict';
// TODO: remove from `core-js@4`
var defineWellKnownSymbol = require('../internals/well-known-symbol-define');

defineWellKnownSymbol('replaceAll');



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/modules/esnext.symbol.replace-all.js
// module id = 752
// module chunks = 13